import Vue from 'vue';

import '@tencent/qcvue2/dist/qcvue.css';
import 'static/cos-browser/cos-browser.css';
import '@/assets/global.scss';
import axios from 'axios';
import { store, mutations } from '@/scripts/store';
import QcVue, { locale as localeQcVue } from '@tencent/qcvue2';
import i18n from '@/scripts/lang';

import '@/scripts/filters/index';
import '@/scripts/directives/index';
import '@/scripts/helper/devmode';
import App from './App';

Vue.config.productionTip = false;
Vue.use(QcVue);
localeQcVue.i18n(key => i18n.t(key));

Vue.prototype.$http = axios;
Vue.prototype.$store = store;
Vue.prototype.$mutations = mutations;

// 从本地存储中读取语言设置，如果没有则使用默认语言
const savedLocale = localStorage.getItem('locale') || store.localeLanguage || 'zh';
i18n.locale = savedLocale;

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app');
